const ICONS = 'https://cdn.jsdelivr.net/npm/@lobehub/icons-static-svg@1.95.1/icons'
const m = (id, label) => ({ id, label })

export const CUSTOM_PROVIDERS_PART01 = [
  {
    id: 'openai',
    label: 'OpenAI',
    tagline: 'GPT-4.1 · o4-mini',
    iconUrl: `${ICONS}/openai.svg`,
    keyPattern: /^sk-[A-Za-z0-9_-]{20,}$/,
    keyHint: 'OpenAI keys start with sk-',
    keyUrl: 'https://platform.openai.com/api-keys',
    models: [m('gpt-4.1', 'GPT-4.1'), m('gpt-4.1-mini', 'GPT-4.1 mini'), m('o4-mini', 'o4-mini'), m('o3', 'o3')],
  },
  {
    id: 'anthropic',
    label: 'Anthropic',
    tagline: 'Claude Sonnet · Opus',
    iconUrl: `${ICONS}/claude-color.svg`,
    keyPattern: /^sk-ant-[A-Za-z0-9_-]{20,}$/,
    keyHint: 'Anthropic keys start with sk-ant-',
    keyUrl: 'https://console.anthropic.com/settings/keys',
    models: [m('claude-sonnet-5-5', 'Claude Sonnet 5.5'), m('claude-opus-5-5', 'Claude Opus 5.5'), m('claude-haiku-4-5', 'Claude Haiku 4.5')],
  },
  {
    id: 'google',
    label: 'Google Gemini',
    tagline: 'Gemini 2.5 Pro · Flash',
    iconUrl: `${ICONS}/gemini-color.svg`,
    keyPattern: /^AIza[0-9A-Za-z_-]{35}$/,
    keyHint: 'Gemini keys start with AIza',
    keyUrl: 'https://aistudio.google.com/app/apikey',
    models: [m('gemini-2.5-pro', 'Gemini 2.5 Pro'), m('gemini-2.5-flash', 'Gemini 2.5 Flash')],
  },
  {
    id: 'xai',
    label: 'xAI',
    tagline: 'Grok 4 · Grok 3 mini',
    iconUrl: `${ICONS}/xai.svg`,
    keyPattern: /^xai-[A-Za-z0-9]{20,}$/,
    keyHint: 'xAI keys start with xai-',
    keyUrl: 'https://console.x.ai',
    models: [m('grok-4', 'Grok 4'), m('grok-3-mini', 'Grok 3 mini')],
  },
]
